<template>
    <div class="fixed-tree">
        <!-- 一级节点 -->
        <div v-for="level1 in treeData" :key="level1.id" class="tree-level level-1">
            <div class="node" @click="handleNodeClick(level1)">
                <!-- 展开/折叠图标（有子节点时显示） -->
                <span class="toggle-icon" v-if="level1.children && level1.children.length"
                    @click.stop="level1.expanded = !level1.expanded">
                    {{ level1.expanded ? '▼' : '►' }}
                </span>
                <!-- 节点文本 -->
                <span class="node-label" :class="{ 'node-active': level1.active }">
                    {{ level1.label }}
                </span>
            </div>

            <!-- 二级节点（仅在展开状态显示） -->
            <div class="tree-children" v-if="level1.children && level1.children.length && level1.expanded">
                <div v-for="level2 in level1.children" :key="level2.id" class="tree-level level-2">
                    <div class="node" @click="handleNodeClick(level2)">
                        <span class="toggle-icon" v-if="level2.children && level2.children.length"
                            @click.stop="level2.expanded = !level2.expanded">
                            {{ level2.expanded ? '▼' : '►' }}
                        </span>
                        <span class="node-label" :class="{ 'node-active': level2.active }">
                            {{ level2.label }}
                        </span>
                    </div>

                    <!-- 三级节点（仅在展开状态显示） -->
                    <div class="tree-children" v-if="level2.children && level2.children.length && level2.expanded">
                        <div v-for="level3 in level2.children" :key="level3.id" class="tree-level level-3">
                            <div class="node" @click="handleNodeClick(level3)">
                                <span class="node-label" :class="{ 'node-active': level3.active }">
                                    {{ level3.label }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FixedTree',
    props: {
        // 接收树形数据，类型为数组，必填
        treeData: {
            type: Array,
            required: true, // 父组件必须传递该数据
            default: () => [] // 默认值为空数组（防止未传递时报错）
        }
    },
    data() {
        return {
        }
    },
    methods: {
        /**
         * 处理节点点击事件
         * @param {Object} node 当前点击的节点
         */
        handleNodeClick(node) {
            // 重置所有节点的选中状态
            this.resetAllActive();
            // 设置当前节点为选中状态
            node.active = true;
            // 可在这里添加节点点击后的业务逻辑
            console.log('选中节点:', node);
            this.$emit('node-click', node); 
        },

        /**
         * 重置所有节点的选中状态
         */
        resetAllActive() {
            // 处理一级节点
            this.treeData.forEach(level1 => {
                level1.active = false;
                // 处理二级节点
                if (level1.children && level1.children.length) {
                    level1.children.forEach(level2 => {
                        level2.active = false;
                        // 处理三级节点
                        if (level2.children && level2.children.length) {
                            level2.children.forEach(level3 => {
                                level3.active = false;
                            });
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.fixed-tree {
    width: 100%;
    max-width: 300px;
    padding: 10px;
    margin-top: 2vh;
    border-radius: 4px;
    font-family: 'Microsoft YaHei', sans-serif;
}

/* 层级容器样式 */
.tree-level {
    transition: all 0.2s ease;
}

/* 节点容器样式 */
.node {
    display: flex;
    align-items: center;
    height: 36px;
    line-height: 36px;
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 2px;
    margin-bottom: 2px;
}

.node:hover {
    background-color: #e8f4fd;
}

/* 展开/折叠图标样式 */
.toggle-icon {
    width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #a29a9a;
    margin-right: 4px;
}

/* 节点文本样式 */
.node-label {
    color: #b8b3b3;
    font-size: 14px;
    user-select: none;
    /* 禁止文本选中 */
}

/* 选中节点样式 */
.node-active {
    color: #1890ff;
    /* 高亮颜色 */
    font-weight: 500;
}

/* 子节点容器样式 */
.tree-children {
    overflow: hidden;
    transition: all 0.3s ease;
}

/* 层级缩进控制 */
.level-1 .node {
    padding-left: 10px;
}

.level-2 .node {
    padding-left: 30px;
    /* 比一级多缩进20px */
}

.level-3 .node {
    padding-left: 50px;
    /* 比二级多缩进20px */
}
</style>